import styled, { css } from 'styled-components';
import { Avatar, Icon, Box, IconSize } from '@bechtel/gds';

export interface RodRequestListStyledProps {
  disable: boolean;
}

export const RodRequestTableStyled = styled(Box).attrs({
  pb: { sm: '200' },
})`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.grey[1000]};
    font-size: ${theme.fontSizes[300]};
    border-bottom: 1px solid ${theme.colors.grey[300]};
    font-family: ${theme.fontFamilies.graphikCompact};
  `}
  grid-row: 1;
  text-align: left;
  margin: 0;
`;

export const AvatarRegularStyled = styled(Avatar)`
  height: 40px;
  width: 40px;
`;

export const IconLayoutContainerStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
  m: { sm: '200' },
})`
  ${({ theme }) => css`
    border: solid 1px ${theme.colors.grey['300']};
    width: ${theme.spacings[700]};
    height: ${theme.spacings[700]};
    border-radius: ${theme.spacings[200]};
    color: ${theme.colors.white};
  `}
  cursor: pointer;
`;

export const ExpiredRodRequestIconStyled = styled(Icon).attrs({
  iconStyle: 'duo',
  icon: 'exclamation-circle',
  size: IconSize.MEDIUM,
  fillColor: 'bechtel.red',
})`
  ${({ theme }) => css`
    border: solid 1px ${theme.colors.white};
    color: ${theme.colors.white};
    width: ${theme.spacings[500]};
    height: ${theme.spacings[500]};
    border-radius: ${theme.spacings[600]};
    background-color: ${theme.colors.bechtel.red};
    left: calc(${theme.spacings[600]} + ${theme.spacings[200]});
  `}
  position: absolute;
`;

export const RodRequestTableRowStyled = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 50% 20% 15% 15%;
  ${({ theme }) => css`
    margin: ${theme.spacings[400]} ${theme.spacings[450]};
  `}
`;

export const RodRequestCountStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[400]};
    font-family: ${theme.fontFamilies.graphik};
  `}
`;

export const CircleStyled = styled(Box).attrs({
  mx: { sm: '300' },
})`
  ${({ theme }) => css`
    width: ${theme.spacings[100]};
    height: ${theme.spacings[100]};
    background-color: ${theme.colors.grey[500]};
    border-radius: ${theme.radii[900]};
  `}
`;

export const RodRequestListStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  width: 100%;
  ${(props: RodRequestListStyledProps) =>
    props.disable &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`;
